import React, {useState, useEffect} from 'react'
import logo from '../images/giaa.png';
import title from '../images/certificate-title.jpg';
import separator from '../images/separator.png';
import badge from '../images/badge.jpg';
import { $ } from 'react-jquery-plugin';

// import '../../src/css/developer3.css';

import '../../src/css/certificate.css';
import axios from "axios";
import { certify, rules } from '../apis/urls';
import moment from 'moment';
import { savePDF, PDFExport } from '@progress/kendo-react-pdf';
import { Navigate, useNavigate, Link, useParams } from "react-router-dom";
import Userimg2 from '../assets/userimg.png'




const Certificate = (props) => {

    const certiRef = React.createRef();
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [association, setAssociation] = useState('');
    const [date, setDate] = useState('');
    const [number, setNumber] = useState('');

    const [result, setResult] = useState([]);
    const [rulesdetails, setRulesDetails] = useState([]);
    let navigate = useNavigate();
    const [amount, setAmount] = useState(0);
    const [coachName, setCoachName] = useState("")

    let token = "Bearer "+localStorage.getItem('token');
    let tokens = localStorage.getItem('token');

    let resetPassword = () => {
        navigate('/reset_password')
    }

     const Logout = () => {
        let urole = localStorage.getItem('userrole');
        localStorage.removeItem('coachlogin');


        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')

           
            navigate("/admin")

        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/rules_list", { replace: true });
        }
        //window.location.href = "gisa/";
    }


    const { rid } = useParams();

useEffect(() => {
    console.log("certificate from use effect");
    certific();
    RuleListing();
    $('body').removeClass('').addClass('sidebar-collapsed');
   
},[]);

let currentYear = new Date().getFullYear();


let datess = moment(result.test_date).format("DDMMYYYY");


const RuleListing = () => {

        

    let token = "Bearer "+localStorage.getItem('token');

    
    
    const instance = axios.create({

        baseURL: rules+"/"+rid,

        timeout: 1000000,

        headers: {'authorization': token}

      });
      
      instance.get('').then((response) =>{
        
        setRulesDetails(response.data.data);  
        console.log('resultssssss',response.data.data)
                 
      }).catch((error) =>{
        
        console.log('error',error.message)
        

      });
}



const certific = () => {

    

    let token = "Bearer "+localStorage.getItem('token');
    let coachId = localStorage.getItem('coachid');
    console.log("coach id is",coachId);

        const data = {
            coach_id:coachId,
            rule_id:rid,
        }
         
        console.log("data is",data);       
        const instance = axios.create({
            baseURL: certify,
            timeout: 1000000,
            
            headers: {'authorization': token,
                     'content-type':"application/json"
        }
        });
        

        instance.post('', data).then(response => {
           
            setResult(response.data.data[0]);


            let element = document.querySelector('.certificate_grid') || document.body;

            savePDF(element, {
                paperSize: 'auto',
                landscape:'true',
                fileName: 'Certificate.pdf',
                margin: 10,
                padding: 20,
                fontSize:'30px'
              });
        
        }).catch(error => {
            
            console.log('error',error)
        });

}

  return (


    <div className="wrapper">
        
    <aside className="right-side ">

         {
                        tokens?
                    (<header>
                        <div className="title-and-userprofile-wrpr" >
                            <div>
                                
                            </div>
                            <div className="user-profile-wrpr nav navbar-nav">
                                <div className="navbar-collapse">
                                    <div className="navbar">
                                    
                                        <ul className="nav user-profile navbar-nav ml-auto text-right">
                                            <ul className="nav-item user-avatar-items dropdown">
                                                <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="/aaa">
                                                                
                                                    <div className="username-and-type">
                                                        <span className="loggedinuser">
                                                            <i className="icon-userimage"></i> <span className="username">User</span>
                                                        </span>
                                                        <span className="usertype">{coachName}</span>
                                                    </div>
                                                    <div className="profile-pic">
                                                        <img src={Userimg2} width="" height="" alt="" />
                                                    </div>
                                                                    
                                                </a>	
        
                                                <div className="dropdown-menu dropdown-menu-right">
                                                    
                                                    <button className="dropdown-item" onClick={ resetPassword }>Reset Password</button>
                                                    <button onClick={Logout} className="dropdown-item" href="#">Logout</button>											
                                                </div>
                                            </ul>
                                        </ul>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </header> ) : null
                    }

        <div className="content-area">


    <div className='certificate_grid' style={{marginLeft:"4.5%"}}>

    {/* <div ref={certiRef}>
        Vishnu
    </div> */}
        <div className="certificate-wrpr" style={{margin:"0 auto"}}>
            <div className="certificate-border">
                <div className="transparent-border">
                    <div className="innerbox">
                        <div className="logo-and-certificate-title-wrpr">
                            <div className="logo-wrpr">
                                {/* <img src="./Certificate_files/logo.jpg" width="" height=""> */}
                                <img src={logo} className="logo" alt="Logo" />
                            </div>
                            <div className="title-wrpr">
                                {/* <img src="./Certificate_files/certificate-title.jpg" width="" height=""> */}
                                <img src={title} className="certify-title" alt="Title" />

                                <div className="sub-title">
                                    of Achievement
                                </div>
                                {/* <img src="./Certificate_files/separator.png" width="" height="" alt=""> */}
                                <img src={separator} className="certify-seperator" alt="seperate" />
                                    
                            </div>
                                <div className="">
                                        &nbsp;
                                    </div>
                            </div>
                            <div className="certify-that">
                                This Certifies that 
                            </div>

                            
                        
                            <div className="dottedline">
                                &nbsp;
                                <span>{result.firstName} {result.last_name}</span>
                            </div>
                            <div className="dottedline">
                                &nbsp;
                                <span>{result.school}</span>
                            </div>
                            <div className="dottedline">
                                <span>Has Successfully Completed {rulesdetails.rule_name}</span>
                            </div>
                        
                            <div className="badge-and-date">
                                <div className="fillwith">
                                    Certificate
                                    <span>{result.certificate_number}</span>
                                </div>
                                <div className="badge">
                                    {/* <Image ="./Certificate_files/badge.jpg" width="" height="" alt=""> */}
                                    <img src={badge} classNameName="certify-seperator" alt="badge" />
                                </div>
                                <div className="completedon">
                                    Completed On
                                    {/* <span>{moment(result.test_date).format('LL')}</span> */}
                                    <span>{result.test_date}</span>
                                </div>
                            </div>
                
                        </div>
                    </div>
                </div>

            </div>

        </div>

        </div>
    </aside>
</div>

  )

}

export default Certificate